import { Col } from 'reactstrap'
import CommonTourSocialMedia from '../Common/CommonTourSocialMedia'

const SocialMediaSection = () => {
  return (
    <Col sm="4" className="align-self-center mt-0 text-end">
      <CommonTourSocialMedia time="3 min ago" className="step6" />
    </Col>
  )
}

export default SocialMediaSection